import React, { useState, useRef, useEffect, Suspense } from 'react';

import { useSelector } from 'react-redux';
import Div100vh from 'react-div-100vh';
// import { Sidebar } from '../../components';
import clsx from 'clsx';
import { LineWave } from 'react-loader-spinner';
import SideMenu from 'components/SideMenu';
import Header from 'components/Header';
import { PopupMessage } from 'components';
import { convertLocaleMobileNumToNumWithDialCode } from 'utils';
// import { ReactComponent as TickOutlineIcon } from 'assets/icons/tick-outline-icon.svg';
import { ReactComponent as InfoOutlineIcon } from 'assets/icons/Icon_Status_Outline_Info.svg';
import PopupMessageNewFace from 'components/PopupMessageNewFace';
import styles from './styles.module.scss';
import SecondSideMenu from './SecondSideMenu';
import { useLocation } from 'react-router-dom';
import { POPUP_NAMES } from 'utils/constants';

// Each item in "newFacePopupContent" can have 'headerLink' and 'featureLink'. The 'featureLink' directs to the respective new feature page, while the 'headerLink' can lead to the same destination or any other location.
const newFacePopupContent = [
  {
    title: 'ربات هوش مصنوعی به رایچت اضافه شد. (نسخه بتا)',
    description: (
      <>
        <p>
          این ربات با بهره گیری از پایگاه دانش شما میتواند پاسخگوی مشتریان شما
          باشد و در صورت لزوم اپراتور های شما تکمیل کننده ی مکالمه و خاتمه دهنده
          ی آن باشند.
        </p>
        <p>
          با دستیار هوشمند رایچت می توانید بسیاری از مکالمات را به هوش مصنوعی
          بسپارید و از تجربه ی کاربری آن لذت ببرید. توجه داشته باشید ربات هوش
          مصنوعی تا قبل از قبول مکالمه عهده دار مکالمه می باشد و همچنین در زمان
          فعال سازی هوش مصنوعی ، حالت انتظار غیر فعال خواهد شد.
        </p>
        <p>
          شما میتوانید در پکیج پریمیوم پلاس هوش مصنوعی را در رایچت تجربه کنید.
        </p>
      </>
    ),
  },
  {
    title: 'ربات پاسخگوی رایچت',
    description: (
      <>
        <p>
          ربات پاسخگوی پشتیبانی رایچت یک راه حل نوآورانه برای ارتقای سطح
          پشتیبانی مشتریان شما است.
        </p>
        <p>
          با این ابزار، شما می‌توانید سوالات متداول را پیش‌تعریف کنید و ربات را
          برای پاسخگویی به سوالات خاص بر اساس نیاز مشتریان آماده کنید.
        </p>
        <p>
          علاوه بر این، امکان تعریف یک فلو برای پاسخگویی گام به گام به سوالات
          مشتریان وجود دارد، که به شما امکان می‌دهد پاسخ‌های دقیق و مرتبط با
          نیازهای مشخص هر مشتری را ارائه دهید.
        </p>
      </>
    ),
  },
  {
    title: 'حالت انتظار',
    description: `اگر دوست داری زمان انتظار مشتریات توی وبسایتت رو براشون قابل تحمل تر
      بکنی، قابلیت انتظار رایچت میتونه کمکت کنه. به وسیله حالت انتظار
      رایچت میتونی اطلاعات کاربرانی که منتظر دریافت پاسخ از سمت پشتیبانی
      هستن رو ازشون بگیری تا سر فرصت بتونی بهشون کمک کنی.`,
  },
  {
    title: 'فرم‌ها',
    description: `وقتی کاربری وارد وبسایتت میشه و میخواد که از بخش پشتیبانی استفاده
      بکنه، نیازه که اطلاعاتش رو توی فیلدهای مشخص شده وارد بکنه تا شما
      بتونید دسترسی بهتری به کاربرتون داشته باشید. با استفاده از این فیچر
      شما میتونید فرم های مختلف رو بنابر نیاز کسب و کارتون درست کنید ودر
      اختیار مشتریاتون قرار بدین و از این طریق لید جمع کنید.`,
  },
];

const getPackageTypes = ({ paymentsData }) => paymentsData.packageTypes;
const getProfile = ({ userData }) => userData.profile;
const getWebsites = ({ websitesData }) => websitesData.websites.data;
const getIsWidgetReady = ({ appData }) => appData.isWidgetReady;
const getLocale = ({ appData }) => appData.locale;

const getWebsitesUrlText = (websites) => {
  const urlList = websites?.map(
    (website) => `${website.title}:  ${website.url}`
  );
  return urlList.join('\n');
};

const getIsSideMenuCollapsed = ({ layoutData }) =>
  layoutData.isSideMenuCollapsed;
const getIsSecondSideMenuCollapsed = ({ layoutData }) =>
  layoutData.isSecondMenuCollapsed;

const Dashboard = ({ children, ...otherProps }) => {
  const isSideMenuCollapsed = useSelector(getIsSideMenuCollapsed);
  const isSecondSideMenuCollapsed = useSelector(getIsSecondSideMenuCollapsed);
  const packageTypes = useSelector(getPackageTypes);
  const profile = useSelector(getProfile);
  const websites = useSelector(getWebsites);
  const isWidgetReady = useSelector(getIsWidgetReady);
  const locale = useSelector(getLocale);

  const [showMenu, setShowMenu] = useState(false);
  const headerWrapperRef = useRef(null);
  const { pathname } = useLocation();

  const siteCountExceedPopupName = 'SITE_EXCEED_WARNING';

  const newFeaturePopupId = 'AI_bot';

  // popups
  const showSiteCountExceedPopup =
    profile.accountType !== 9 && profile.maxSiteCount < websites?.length;

  const renderSiteCountExceedPopupContent = (
    <div>
      <div className={clsx([styles.popup_icon__wrapper, styles.warning])}>
        <InfoOutlineIcon className={clsx([styles.popup_icon])} />
      </div>
      <div>
        <h2>دوست عزیز رایچت</h2>
        <p>
          همونطور که میدونید پکیج های رایچت دارای ظرفیت استفاده هستند و شما می
          تونید با خرید یک پکیج، بنا بر ویژگی ها و ظرفیت اون پکیج، رایچت رو روی
          تعداد محدودی وبسایت نصب کنید.
          <br />
          دو ساله که این قانون رو برای استفاده از خدماتمون داریم اما به دلیل
          استقبال و وفاداری مشتریانمون، هیچوقت اعمالش نکردیم. از هفته آینده
          قراره که این قانون اعمال بشه و از شما میخواهیم که با توجه به سیاست
          مصرف منصفانه، نسبت به ارتقا پکیج های رایچتتون اقدام کنید تا بتونید
          همجنان رایچت رو روی تمامی وبسایت های ثبت شده تون داشته باشید.
        </p>
      </div>
    </div>
  );

  // setting user's data by Raychat API
  useEffect(() => {
    if (isWidgetReady && profile && packageTypes && websites) {
      window.Raychat?.setUser({
        email: profile.email,
        name: profile.fullName,
        about: `پکیج: ${packageTypes[profile.accountType]?.[locale]}
        سایت‌ها:
        ${getWebsitesUrlText(websites)}`,
        phone: convertLocaleMobileNumToNumWithDialCode(profile.mobile),
        avatar: profile.image,
        updateOnce: false,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isWidgetReady, profile, websites, packageTypes]);

  useEffect(() => {
    const main_layout_el = document.querySelector('#main_layout');
    main_layout_el?.scrollTo(0, 0);
  }, [pathname]);

  return (
    <Div100vh
      style={{ width: '100%' }}
      //  className='CustomContainer'
    >
      <div className='dashboard_wrapper'>
        <div className='that-linear-gradiant-bg'></div>

        {showSiteCountExceedPopup && (
          <PopupMessage
            popupName={siteCountExceedPopupName}
            content={renderSiteCountExceedPopupContent}
          />
        )}

        {/* <PopupMessage
          content={renderNewFeaturesPopupContent}
          popupName={newFeaturesPopupName}
        /> */}

        <PopupMessageNewFace
          popupContent={newFacePopupContent}
          popupName={POPUP_NAMES.NEW_FEATURES}
          popupId={newFeaturePopupId}
        />

        <div className='sideMenu_wrapper' data-collapse={isSideMenuCollapsed}>
          <SideMenu
            {...{
              showMenu,
              setShowMenu,
            }}
          />
          <SecondSideMenu
            {...{
              // showMenu,
              setShowMenu,
            }}
          />
        </div>

        <div
          className='main_layout'
          id='main_layout'
          data-second-menu-collapse={isSecondSideMenuCollapsed}
        >
          <div ref={headerWrapperRef} className='headerWrapper'>
            <Header {...{ showMenu, setShowMenu }} />
          </div>

          <Suspense
            fallback={
              <div className='loader_container'>
                <LineWave
                  height={120}
                  width={120}
                  color='rgb(177, 14, 132)'
                  ariaLabel='line-wave'
                  wrapperStyle={{}}
                  wrapperClass=''
                  visible={true}
                />
              </div>
            }
          >
            <div
              // style={{
              //   maxHeight: `calc(100vh - ${
              //     32 + // padding-top of whole layout
              //     48 + // header height
              //     (59 - 42) // header's margin-bottom
              //   }px)`,
              // }}
              id='page_layout'
              className='page_layout CustomContainer'
            >
              {children}
            </div>
          </Suspense>
        </div>
      </div>
    </Div100vh>
  );
};

export default Dashboard;
